import React, {
  createContext,
  useState,
  useMemo,
  useContext,
  useCallback
} from 'react';
import PropTypes from 'prop-types';
import { useRouteMatch } from 'react-router-dom';
import { useQuickFilterState, useIsPtiEnabled } from '~/modules/common/hooks';

export const RESOURCE_ALLOCATION_CHART_TAB_ENUM = {
  ALL: 'ALL',
  PENDING: 'PENDING',
  PROPOSED: 'PROPOSED',
  TOBEHIRED: 'TOBEHIRED'
};

export const RESOURCE_ALLOCATION_CHART_SUB_TAB_ENUM = {
  ALL: 'ALL',
  TOBEHIRED: 'TOBEHIRED',
  HIRINGREQUESTED: 'HIRINGREQUESTED'
};

export const getPlanStatus = ({ params: { planStatus } = {} }) => {
  if (!planStatus) return {};

  return {
    planStatus: planStatus.toUpperCase()
  };
};
export const ResourceAllocationChartTabContext = createContext();

export const ResourceAllocationChartTabContextProvider = ({ children }) => {
  const { planStatus } = getPlanStatus(useRouteMatch());
  const initialPlanStatus =
    planStatus || RESOURCE_ALLOCATION_CHART_TAB_ENUM.PENDING;

  const [selectedChartTab, setSelectedChartTab] = useState(initialPlanStatus);

  const isPtiEnabled = useIsPtiEnabled();

  const [
    quickFilter,
    setQuickFilter,
    loadingQuickFilters
  ] = useQuickFilterState({
    filterKey: 'hiring-request-filter',
    defaultValue: RESOURCE_ALLOCATION_CHART_SUB_TAB_ENUM.ALL
  });

  const handleSetQuickFilter = useCallback(
    (newAllKey, newKey) => {
      setQuickFilter({ filterByAccess: newAllKey, filterByStatus: newKey });
    },
    [setQuickFilter]
  );

  const value = useMemo(
    () => ({
      selectedChartTab,
      setSelectedChartTab,
      ...(isPtiEnabled && {
        summaryFilterState: {
          quickFilter,
          setKeys: handleSetQuickFilter,
          isLoadingQuickFilters: loadingQuickFilters
        }
      })
    }),
    [
      handleSetQuickFilter,
      isPtiEnabled,
      loadingQuickFilters,
      quickFilter,
      selectedChartTab
    ]
  );

  return (
    <ResourceAllocationChartTabContext.Provider value={value}>
      {children}
    </ResourceAllocationChartTabContext.Provider>
  );
};

ResourceAllocationChartTabContextProvider.propTypes = {
  children: PropTypes.object
};

export const useResourceAllocationChartTabStateContext = () => {
  const { selectedChartTab, setSelectedChartTab, summaryFilterState } =
    useContext(ResourceAllocationChartTabContext) || {};

  return {
    selectedChartTab,
    setSelectedChartTab,
    summaryFilterState
  };
};

export default useResourceAllocationChartTabStateContext;
